<template>
    <div class="confirm-group" @click="prevent = true">
        <div class="popover confirmation" v-if="confirm">
            <div class="arrow" style="left: 50%;"></div>
            <h3 class="popover-title">Are you sure?</h3>
            <div class="popover-content text-center">
                <div class="btn-group">
                    <a class="btn btn-sm btn-success" @click.prevent="$emit('confirm'); confirm = false">
                        <i class="glyphicon glyphicon-ok"></i> Yes 
                    </a>
                    <a class="btn btn-sm btn-danger" @click.prevent="confirm = false;">
                        <i class="glyphicon glyphicon-remove"></i> No 
                    </a>
                </div>
            </div>
        </div>
        <button class="btn btn-danger" @click.prevent="confirm = true">
            <slot></slot>
        </button>
    </div>
</template>
<style>
    .confirm-group {
        position: relative;
        display: inline-block;
    }
    .confirm-group .popover {
        transform: translate(-50%, -100%);
        display: block;
        min-width: 160px;
        left: 50%;
    }
</style>
<script>
export default {
    data() {
        return {
            confirm: false,
            clickHandler: null
        };
    },
    methods: {
        outsideClick() {
            if (this.prevent) {
                this.prevent = false;
            }
            else {
                this.confirm = false;
            }
        },    
    },
    mounted() {
        this.clickHandler = this.outsideClick.bind(this);
        document.addEventListener('click', this.clickHandler, false);    
    },
    destroyed() {
        document.removeEventListener('click', this.clickHandler);
    }
}; 
</script>


// WEBPACK FOOTER //
// resources/js/ui/ConfirmPopover.vue